module.exports = __webpack_public_path__ + "img/29_21.5bceccd9.png";